import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Typography, Box } from '@mui/material';
import { IconChevronDown } from '@tabler/icons-react';
import NavItem from './../NavItem';

const NavCollapse = ({ menu, level }) => {
    const customization = useSelector((state) => state.customization);
    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
        setOpen(!open);
    };

    return (
        <>
            {/* Group Header (Accounting, Admin, Masters etc) */}
            <ListItemButton
                onClick={handleClick}
                disableGutters
                sx={{
                    padding: '6px 8px !important',
                    display: 'grid',
                    gridTemplateColumns: '28px 1fr 16px',
                    alignItems: 'center',
                    fontWeight: 700,

                    '&:hover': { backgroundColor: '#f5f7fb' }
                }}
            >
    <Box sx={{ width: 28, display: 'flex', justifyContent: 'center' }}>
        {menu.icon && <menu.icon size={20} />}
    </Box>

    <Box sx={{ flexGrow: 1 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 700 }}>
            {menu.title}
        </Typography>
    </Box>

    <IconChevronDown size={16} />
</ListItemButton>


            <Collapse
                in={open}
                timeout={0}
                unmountOnExit
                sx={{
                    '& .MuiCollapse-wrapperInner': {
                    padding: 0,
                    margin: 0
                    }
                }}
                >
                <List disablePadding sx={{ p: 0, mt: 0.5 }}>
                    {menu.children.map((item) => (
                        <NavItem key={item.id} item={item} level={level + 1} />
                    ))}
                </List>
            </Collapse>
        </>
    );
};

NavCollapse.propTypes = {
    menu: PropTypes.object,
    level: PropTypes.number
};

export default NavCollapse;